import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { PersonalDocument } from '../models/personal-document.model';
import { JobService } from '../services/sections/job/job.service';
import { MyCloudService } from '../services/sections/job/my-cloud.service';

@Injectable({
	providedIn: 'root'
})
export class CloudDocumentsResolver implements Resolve<Observable<PersonalDocument[]>> {
	constructor(
		private router: Router,
		private myCloudService: MyCloudService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.myCloudService
			.getMyCloudDocuments(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.router.navigate(['/404']);
					return NEVER;
				})
			);
	}
}
